<form
  *ngIf="(configOptions$ | async)?.length > 0"
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="formValues"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="defaultCategories"
        >
          <span class="fs-3">{{
            'general.defaultCategories' | translate
          }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>
    <div *ngIf="!isCollapsed" class="card-body" id="defaultCategories">
      <!-- No category & explanation -->
      <fieldset class="mb-4" *ngIf="hasExtendedCategories">
        <legend class="form-label" id="noCatLabel"
          >{{ 'general.noCategory' | translate }}
        </legend>
        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-nl"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-5"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="noCatLabel flag-nl-5"
                formControlName="nl_category0desc"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-en"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-5"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="noCatLabel flag-en-5"
                formControlName="en_category0desc"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-fr"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-5"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="noCatLabel flag-fr-5"
                formControlName="fr_category0desc"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-de"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-5"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="noCatLabel flag-de-5"
                formControlName="de_category0desc"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="mb-4" *ngIf="hasExtendedCategories">
        <legend class="form-label" id="noCatExplLabel">
          {{ 'general.noCategory' | translate }}
          {{ 'general.explanation' | translate | lowercase }}
        </legend>
        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-nl"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-6"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="noCatExplLabel flag-nl-6"
                formControlName="nl_category0_explanation"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-en"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-6"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="noCatExplLabel flag-en-6"
                formControlName="en_category0_explanation"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-fr"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-6"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="noCatExplLabel flag-fr-6"
                formControlName="fr_category0_explanation"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-de"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-6"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="noCatExplLabel flag-de-6"
                formControlName="de_category0_explanation"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <!-- End no category & explanation-->

      <ng-container *ngFor="let category of arrayCategories; let i = index">
        <!-- general category-->
        <fieldset class="mb-4">
          <legend class="form-label" id="categoryLabel{{ i + 1 }}"
            >{{ 'general.category' | translate }} {{ i + 1 }}
          </legend>
          <div class="row g-2">
            <div class="col-lg-6" *ngIf="availableLanguages['nl']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-nl"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                    id="flag-nl-id-{{ i + 1 }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="categoryLabel{{ i + 1 }} flag-nl-id-{{
                    i + 1
                  }}"
                  formControlName="{{ 'nl_category' + category + 'desc' }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['en']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-en"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                    id="flag-en-id-{{ i + 1 }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="categoryLabel{{ i + 1 }} flag-en-id-{{
                    i + 1
                  }}"
                  formControlName="{{ 'en_category' + category + 'desc' }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['fr']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-fr"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                    id="flag-fr-id-{{ i + 1 }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="categoryLabel{{ i + 1 }} flag-fr-id-{{
                    i + 1
                  }}"
                  formControlName="{{ 'fr_category' + category + 'desc' }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['de']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-de"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                    id="flag-de-id-{{ i + 1 }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="categoryLabel{{ i + 1 }} flag-de-id-{{
                    i + 1
                  }}"
                  formControlName="{{ 'de_category' + category + 'desc' }}"
                />
              </div>
            </div>
          </div>
        </fieldset>
        <!-- END general category-->

        <!-- Cateogory Explanation-->
        <fieldset class="mb-4">
          <legend class="form-label" id="catExplLabel{{ i + 1 }}">
            {{ 'general.category' | translate }} {{ i + 1 }}
            {{ 'general.explanation' | translate | lowercase }}
          </legend>
          <div class="row g-2">
            <div class="col-lg-6" *ngIf="availableLanguages['nl']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-nl"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                    id="lang-nl-b{{ i + 1 }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catExplLabel{{ i + 1 }} lang-nl-b{{
                    i + 1
                  }}"
                  formControlName="{{
                    'nl_category' + category + '_explanation'
                  }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['en']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-en"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                    id="lang-en-b{{ i + 1 }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catExplLabel{{ i + 1 }} lang-en-b{{
                    i + 1
                  }}"
                  formControlName="{{
                    'en_category' + category + '_explanation'
                  }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['fr']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-fr"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                    id="lang-fr-b{{ i + 1 }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catExplLabel{{ i + 1 }} lang-fr-b{{
                    i + 1
                  }}"
                  formControlName="{{
                    'fr_category' + category + '_explanation'
                  }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['de']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-de"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                    id="lang-de-b{{ i + 1 }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catExplLabel{{ i + 1 }} lang-de-b{{
                    i + 1
                  }}"
                  formControlName="{{
                    'de_category' + category + '_explanation'
                  }}"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </ng-container>

      <div class="form-footer sticky-bottom">
        <button class="btn btn-primary" type="submit">
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
